import { render, staticRenderFns } from "./multilangTextarea.vue?vue&type=template&id=7cc536f6&"
import script from "./multilangTextarea.vue?vue&type=script&lang=js&"
export * from "./multilangTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports